<script>
import { Radar, mixins } from 'vue-chartjs'

export default {
  extends: Radar,
  name: 'RadarChart',
  mixins: [mixins.reactiveProp],
  data() {
    return {
      legendHtml: '',
      existingLegend: [],
      isLoaded: false,
      data: {},
      chartOptions: {
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'top',
          align: 'end'
        },
        elements: {
          point: {
            radius: this.adjustRadiusBasedOnData,
            hoverRadius: 16
          }
        },
        scale: {
          angleLines: {
            display: false
          },
          ticks: {
            beginAtZero: true,
            suggestedMax: 5,
            stepSize: 1
          }
        }
      }
    }
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    }
  },
  mounted() {
    // this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.chartOptions)
  },
  methods: {
    refresh() {
      this.renderChart(this.chartData, this.chartOptions)
    },
    adjustRadiusBasedOnData(ctx) {
      let v = ctx.dataset.data[ctx.dataIndex]
      return Math.log(v + 2) * 7.5
    }
  }
}
</script>

<style lang="scss" scoped></style>
